var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _line, _line2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGraphbar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 467,
    height: 175,
    viewBox: "0 0 467 175",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 26.1716,
    y: 37,
    width: 18.8109,
    height: 106,
    fill: "#ED7575"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 100.597,
    y: 51,
    width: 18.8109,
    height: 92,
    fill: "#ED7575"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 175.023,
    y: 103,
    width: 18.8109,
    height: 40,
    fill: "#ED7575"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 249.448,
    y: 68,
    width: 18.8109,
    height: 75,
    fill: "#ED7575"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 323.874,
    y: 37,
    width: 18.8109,
    height: 106,
    fill: "#ED7575"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 398.3,
    y: 103,
    width: 18.8109,
    height: 40,
    fill: "#ED7575"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 57.2505,
    y: 68,
    width: 18.8109,
    height: 75,
    fill: "#39C660"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 131.676,
    y: 37,
    width: 18.8109,
    height: 106,
    fill: "#39C660"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 206.102,
    y: 80,
    width: 18.8109,
    height: 63,
    fill: "#39C660"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 280.527,
    y: 68,
    width: 18.8109,
    height: 75,
    fill: "#39C660"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 354.953,
    y: 122,
    width: 18.8109,
    height: 21,
    fill: "#39C660"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 429.378,
    y: 91,
    width: 18.8109,
    height: 52,
    fill: "#39C660"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 467,
    y1: 174.5,
    y2: 174.5,
    stroke: "#808299"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: -2.18557e-8,
    x2: 0.500008,
    y2: 174,
    stroke: "#808299"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphbar);
export default __webpack_public_path__ + "static/media/graphbar.6e117f999449bda91c6641683df7147d.svg";
export { ForwardRef as ReactComponent };